import Terms from './screens/Terms';
import Sustainability from './screens/Sustainability';
import Contact from './screens/Contact';
import About from './screens/About';
import Privacy from './screens/Privacy';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './screens/LandingPage';
import BookingPortal from './screens/BookingPortal';
import AdminDashboard from './screens/AdminDashboard';
import ResetPassword from './screens/ResetPassword';
import SplashScreen from './components/SplashScreen';

import Navbar from './components/Navbar';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <Router>
      <ScrollToTop />
      <div className="w-screen min-h-screen flex flex-col bg-background overflow-x-hidden text-on-surface">
        {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/booking" element={<BookingPortal />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
